import React from "react";
import Layout from "../../components/layout/Layout";
import CastingCallEdit from "../../components/castingCalls/CastingCallEdit";

const CastingCallEditPage = () => {
  return (
    <Layout>
      <div>
        <CastingCallEdit />
      </div>
    </Layout>
  );
};

export default CastingCallEditPage;
